import templateUrl from "emun.auth/register-consumer-prompt.htm";
import open from "webmodals/open";
import $session from "servicestack/session";
import ModalController from "webmodals/modal.controller";

export class RegisterConsumerPromptController extends ModalController {
  constructor($uibModalInstance, options) {
    super($uibModalInstance);
    let $ctrl = this;
    $ctrl.bus = $session.bus;
    $ctrl.title = options.title || "Sign in to your account";
    $ctrl.useQuickRegistration = options.useQuickRegistration;

    $ctrl.request = {
      role: "Consumer",
      autoLogin: true,
    };
  }

  submit() {
    let $ctrl = this;
    if ($ctrl.useQuickRegistration) {
      return $ctrl.bus
        .send(`auth/register/${$ctrl.request.role}.json`, $ctrl.request)
        .then($ctrl.$close);
    }
    return $session
      .register($ctrl.request)
      .then($ctrl.$close, (res) => console.warn("no auth", $ctrl, res));
  }
}

export default (options) =>
  open({
    size: options.size || "md",
    backdrop: "static",
    templateUrl: options.templateUrl || templateUrl,
    controller: RegisterConsumerPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options,
    },
  }).result;
